// Esc closes the chat pop-up (web).
//
// The pop-up is a dialog over the page and, unlike the native sheet, it has no
// backdrop to tap: closing it meant aiming at the × or at the avatar. Esc is the
// keyboard's standing answer to "dismiss this", and without it a keyboard user
// had no way out of the pop-up at all.
//
// Deliberately NOT a click-outside dismissal: the pop-up holds a message the
// user may be halfway through typing, and every chat widget that closes on a
// stray click eats that draft.
//
// `document` is reached for behind a web gate (I-2) — this is the one API that
// gives a window-level key without racing the pop-up's own focus, and the hook
// is inert on native, where the sheet's own backdrop and the hardware back
// button already cover it.
import { useEffect } from 'react';
import { Platform } from 'react-native';

export function useEscapeToClose(active: boolean, onEscape: () => void): void {
  useEffect(() => {
    if (Platform.OS !== 'web' || !active || typeof document === 'undefined') return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onEscape();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [active, onEscape]);
}
